import serviceBase from "./serviceBase";

const fourSquarePlaces = {
  getFourSquarePlaces: (data) => serviceBase.post("/fourSquare", data),
};
export default fourSquarePlaces;
